import { useEffect } from "react";
import { TCameraOptions } from "../scanview.types";

const useCustomWidget = (
  autoSwitchActiveColor?: string,
  autoSwitchInactiveColor?: string,
  progressBarColor?: string,
  widgetBackgroundColor?: string,
  messageFontSize?: string,
  messageTextColor?: string,
  messageBackgroundColor?: string,
  cameraOptions?: TCameraOptions
) => {
  useEffect(() => {
    if (messageFontSize) {
      document.documentElement.style.setProperty(
        "--cardscan-message-font-size",
        messageFontSize
      );
    }
    if (messageTextColor) {
      document.documentElement.style.setProperty(
        "--cardscan-message-text-color",
        messageTextColor
      );
    }
    if (messageBackgroundColor) {
      document.documentElement.style.setProperty(
        "--cardscan-message-background-color",
        messageBackgroundColor
      );
    }
    if (widgetBackgroundColor) {
      document.documentElement.style.setProperty(
        "--cardscan-widget-background-color",
        widgetBackgroundColor
      );
    }
    if (progressBarColor) {
      document.documentElement.style.setProperty(
        "--cardscan-progress-bar-color",
        progressBarColor
      );
    }
    if (autoSwitchActiveColor) {
      document.documentElement.style.setProperty(
        "--cardscan-auto-switch-active-color",
        autoSwitchActiveColor
      );
    }
    if (autoSwitchInactiveColor) {
      document.documentElement.style.setProperty(
        "--cardscan-auto-switch-inactive-color",
        autoSwitchInactiveColor
      );
    }

    document.documentElement.style.setProperty(
      "--cardscan-video-flip-horizontal",
      cameraOptions?.flipHorizontal ? "scaleX(-1)" : "scaleX(1)"
    );
    document.documentElement.style.setProperty(
      "--cardscan-video-flip-vertical",
      cameraOptions?.flipVertical ? "scaleY(-1)" : "scaleY(1)"
    );
  }, [
    messageFontSize,
    messageTextColor,
    messageBackgroundColor,
    widgetBackgroundColor,
    progressBarColor,
    autoSwitchActiveColor,
    autoSwitchInactiveColor,
  ]);
};

export default useCustomWidget;
